import {Component, Input} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AutoUnsubscribe} from '../../../../../infrastructure/decorators/auto-unsubscribe.decorator';
import {VendorService} from 'src/app/vendor/service/vendor.service';
import {HttpParams} from '@angular/common/http';

@AutoUnsubscribe()
@Component({
    selector: 'app-vendor-viewer',
    templateUrl: './vendor-viewer.component.html',
    standalone: false
})
export class VendorViewerComponent {
  @Input()
  public data: any;

  @Input()
  public update: any;

  public _vendor: any;

  public tramsCentralDocumentId: any;

  constructor(private route: ActivatedRoute,
    private vendorService: VendorService) {	
  }

  public ngOnInit(): void {
    if (this.data == null) {
      this.route.paramMap.subscribe(params => {
        this.tramsCentralDocumentId = params.get('tramsCentralDocumentId');
        this.getVendorInfoForPage();
      });
    }
    else if (this.data.vendorContact != null || this.data.address != null){
      this.getVendorInfoForServicesPagePopup();
    }
    else {
      this.getVendorInfoForGeneralPopup();
    }
  }

  public getVendorInfoForPage(): void {
    const params = new HttpParams().set('tramsCentralDocumentId', this.tramsCentralDocumentId);
    this.vendorService.getVendorByKey(params).subscribe((data) => {
      this._vendor = data.items[0];
      this._vendor.isModal = this.data != null;
      this._vendor.title = "Vendor Information"
    });
  }

  public getVendorInfoForServicesPagePopup(): void {
    this._vendor = this.data;
    this._vendor.isModal = this.data != null;
    this._vendor.vendorFullAddress = this.GetVendorFullAddress(this._vendor);
    this._vendor.vendorContactPerson = this.data.vendorContact?.vendorContactName || '';
    this._vendor.vendorContactEmail = this.data.vendorContact?.vendorContactEmail || '';
    this._vendor.vendorContactPhone = this.data.vendorContact?.vendorContactPhone || '';
  }

  public getVendorInfoForGeneralPopup(): void {
    this._vendor = this.data;
  }

  private GetVendorFullAddress(vendor: any) : string {
      return [
        vendor?.address?.addressLine1,
        vendor?.address?.addressLine2,
        vendor?.address?.city,
        vendor?.address?.province,
        vendor?.address?.country?.name,
        vendor?.address?.zipCode
      ].map(v => v?.trim()).filter(v => !!v).join(' ');
    }
}
